import { render, staticRenderFns } from "./GrubtechForm.vue?vue&type=template&id=2f46ca08"
import script from "./GrubtechForm.vue?vue&type=script&lang=ts"
export * from "./GrubtechForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports